import React, { useState } from 'react';
import { PlusCircleIcon, XCircleIcon } from '@fronton/icons-react';
import cn from 'clsx';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { CABINET_ELEMENT_BLOCK } from '../../cabinet-constants';
import {
  cabinetParticularityCard,
  cabinetParticularityCardIcon,
  cabinetParticularityCardImage,
  cabinetParticularityCardOpen,
  cabinetParticularityCardTitle,
  cabinetParticularityFlipCard,
  cabinetParticularityFlipCardBack,
  cabinetParticularityGrid,
} from './cabinet-peculiarities-styles';
import { CABINET_PARTICULARITY_LIST } from './cabinet-peculiarities-constants';

export const CabinetPeculiarities = () => {
  const [activeCard, setActiveCard] = useState<Record<string, boolean>>({});

  const handleCardClick = (cardIndex: number) => () => {
    setActiveCard({
      ...activeCard,
      [cardIndex]: !Boolean(activeCard[cardIndex]),
    });

    analyticsUtils.clickButtonEvent(
      CABINET_ELEMENT_BLOCK,
      CABINET_PARTICULARITY_LIST[cardIndex].elementText,
      'Делаем стильно, надёжно и качественно'
    );
  }

  return (
    <Section>
      <SectionSubTitle margin="m">
        Делаем стильно, надёжно и качественно
      </SectionSubTitle>
      <div className={cabinetParticularityGrid}>
        {CABINET_PARTICULARITY_LIST.map(({ image, title, description }, index: number) => (
          <div
            className={cn(
              cabinetParticularityCard,
              { [cabinetParticularityCardOpen]: activeCard[index] }
            )}
            onClick={handleCardClick(index)}
            key={createElementKey('particularity', index)}
          >
            <div className={cabinetParticularityFlipCard}>
              <Typography className={cabinetParticularityCardTitle} variant="h3">{title}</Typography>
              <picture>
                <source srcSet={image.srcLd} media={strictBreakpoints['--only-largeDesktop']} />
                <img
                  alt={image.alt}
                  className={cabinetParticularityCardImage}
                  src={image.src}
                  width={200}
                  height={230}
                />
              </picture>
              <PlusCircleIcon className={cabinetParticularityCardIcon} type='fill' size='xxl' color='text-primary' />
            </div>
            <div className={cn(cabinetParticularityFlipCard, cabinetParticularityFlipCardBack)}>
              <Typography className={cabinetParticularityCardTitle} variant="h3">{title}</Typography>
              <Typography variant="l" size="body_short">{description}</Typography>
              <XCircleIcon className={cabinetParticularityCardIcon} type='fill' size='xxl' color='text-primary' />
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
};
